import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * FooterItemsApi - axios parameter creator
 * @export
 */
const FooterItemsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/FooterItems/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/FooterItems/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFooterStructured: async (options = {}) => {
            const localVarPath = `/v1/FooterItems/GetFooterStructured`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FooterItemToken} [FooterItemToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (FooterItemToken, options = {}) => {
            const localVarPath = `/v1/FooterItems/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FooterItemToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [id]
         * @param {CustomDeleteBehavior} [removeAll]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, removeAll, options = {}) => {
            const localVarPath = `/v1/FooterItems/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (removeAll !== undefined) {
                localVarQueryParameter['removeAll'] = removeAll;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FooterItemToken} [FooterItemToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (FooterItemToken, options = {}) => {
            const localVarPath = `/v1/FooterItems/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FooterItemToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FooterItemTokenList} [FooterItemTokenList]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAll: async (FooterItemTokenList, options = {}) => {
            const localVarPath = `/v1/FooterItems/UpdateAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(FooterItemTokenList, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * FooterItemsApi - functional programming interface
 * @export
 */
const FooterItemsApiFp = function (configuration) {
    const localVarAxiosParamCreator = FooterItemsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FooterItemsApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FooterItemsApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFooterStructured(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFooterStructured(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FooterItemsApi.getFooterStructured']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FooterItemToken} [FooterItemToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(FooterItemToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(FooterItemToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FooterItemsApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [id]
         * @param {CustomDeleteBehavior} [removeAll]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, removeAll, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, removeAll, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FooterItemsApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FooterItemToken} [FooterItemToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(FooterItemToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(FooterItemToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FooterItemsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FooterItemTokenList} [FooterItemTokenList]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAll(FooterItemTokenList, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAll(FooterItemTokenList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FooterItemsApi.updateAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * FooterItemsApi - factory interface
 * @export
 */
const FooterItemsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FooterItemsApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFooterStructured(options) {
            return localVarFp.getFooterStructured(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FooterItemToken} [FooterItemToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(FooterItemToken, options) {
            return localVarFp.insert(FooterItemToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [id]
         * @param {CustomDeleteBehavior} [removeAll]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, removeAll, options) {
            return localVarFp.remove(id, removeAll, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FooterItemToken} [FooterItemToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(FooterItemToken, options) {
            return localVarFp.update(FooterItemToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {FooterItemTokenList} [FooterItemTokenList]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAll(FooterItemTokenList, options) {
            return localVarFp.updateAll(FooterItemTokenList, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FooterItemsApi - object-oriented interface
 * @export
 * @class FooterItemsApi
 * @extends {BaseAPI}
 */
class FooterItemsApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FooterItemsApi
     */
    getAll(options) {
        return FooterItemsApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FooterItemsApi
     */
    getById(id, options) {
        return FooterItemsApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FooterItemsApi
     */
    getFooterStructured(options) {
        return FooterItemsApiFp(this.configuration).getFooterStructured(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {FooterItemToken} [FooterItemToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FooterItemsApi
     */
    insert(FooterItemToken, options) {
        return FooterItemsApiFp(this.configuration).insert(FooterItemToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {number} [id]
     * @param {CustomDeleteBehavior} [removeAll]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FooterItemsApi
     */
    remove(id, removeAll, options) {
        return FooterItemsApiFp(this.configuration).remove(id, removeAll, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {FooterItemToken} [FooterItemToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FooterItemsApi
     */
    update(FooterItemToken, options) {
        return FooterItemsApiFp(this.configuration).update(FooterItemToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {FooterItemTokenList} [FooterItemTokenList]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FooterItemsApi
     */
    updateAll(FooterItemTokenList, options) {
        return FooterItemsApiFp(this.configuration).updateAll(FooterItemTokenList, options).then((request) => request(this.axios, this.basePath));
    }
}

export { FooterItemsApi, FooterItemsApiAxiosParamCreator, FooterItemsApiFactory, FooterItemsApiFp };
//# sourceMappingURL=footer-items-api.js.map
